module.exports = __webpack_public_path__ + "img/start.dbe5e994.png";